import { apolloClient } from "@td/ui";
import FETCH_STATES_QUERY from "../queries/fetch_states.graphql";

const responseSelector = ({ data: { refStates }}) => refStates.map(({ stateCd, stateName }) => ({
  value: stateCd,
  label: stateName,
}));

const loadStates = async () => {
  const data = await apolloClient.query({
    query: FETCH_STATES_QUERY,
    fetchPolice: "network-only",
  });

  return responseSelector(data);
};

export default loadStates;
